import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@emotion/react'

import { CookieBannerStyles } from './CookieBanner.styles'
import Button from '../../components/Button'

const cookiesAcceptedKey = 'cookiesAccepted'

const CookieBanner: React.FC = () => {
  const { t } = useTranslation()
  const { privacyPolicyLink } = useTheme()
  const [showCookieBanner, setShowCookieBanner] = useState(() => {
    const cookiesAccepted = localStorage.getItem(cookiesAcceptedKey)
    return !Boolean(cookiesAccepted)
  })

  const handleOKClick = () => {
    localStorage.setItem(cookiesAcceptedKey, 'true')
    setShowCookieBanner(false)
  }

  return showCookieBanner ? (
    <CookieBannerStyles data-testid="cookie-banner">
      <p>
        {t('cookie_banner_text')}{' '}
        <a href={privacyPolicyLink || '/'} target="_blank" rel="noopener noreferrer">
          {t('learn_more')}
        </a>
      </p>

      <Button onClick={handleOKClick}>OK</Button>
    </CookieBannerStyles>
  ) : null
}

export default CookieBanner
